class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    var _this = this;
    this.enableLoading(line);
var monogram = ''; 
    var monogram_cart = ''; 
  if ($(`#CartDrawer-Item-${line}`).text().indexOf('Monogramming:') > -1 ) {
       monogram = 1;
       }
if($(`#CartItem-${line}`).text().indexOf('Monogramming:') > -1){
monogram_cart = 1;
}
var random_no= $('#CartDrawer-Item-'+line).attr('data-item-random'); 
   var product_type = $('#CartDrawer-Item-'+line).attr('data-type');
  
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
var flag =0;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        setTimeout(function(){
        $('.cart-item').each(function(index){
        if($(this).attr('data-meta-bundle')=='false' && !$(this).attr('data-item-random') && $(this).attr('data_type') != 'Mobile Case'){
               flag =1 
            }
           
            if(flag == 0 ){
            
                $('.main-product-type-bundle').addClass('hide_bndl');
            }else if (flag =1 ){
              
             $('.main-product-type-bundle').removeClass('hide_bndl');
                
            }
        });
},200)
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
      if(window.location.href.indexOf("cart") < 0){
       
        if(monogram == 1){
      var mongram_QTY = 0;
      $('.cart-item').each(function(index){
       if ($(this).find("quantity-input .quantity__input").hasClass('monogram_line_property') == true){
           mongram_QTY = mongram_QTY + parseInt($(this).find("quantity-input .quantity__input.monogram_line_property").attr('value'));
       }
      });
         var body = { quantity:mongram_QTY, id:30672622157893, sections:_this.getSectionsToRender().map((section) => section.section),sections_url: window.location.pathname};
             $.ajax({
                method: "POST",
                dataType: 'json',
                url:'/cart/change.js',
                async: false,
                data:body,
                success: function(data) {
                  const parsedState = data;
        _this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        _this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            _this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        _this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
                },
             error:function(response){
               console.log(response);
               return false;
             }
           });
     
        }
      }
 if (product_type == 'bundle_product'){
         
          $('.cart-item').each(function(index){
          if($(`.product-option:contains(${random_no})`,this).length > 0){
               console.log(random_no);
          // var id=$(this).attr('data-id');
           var id=$(this).attr('data-key');
          var body = { quantity:quantity, id:id, sections:_this.getSectionsToRender().map((section) => section.section),sections_url: window.location.pathname};
         
             $.ajax({
                method: "POST",
                dataType: 'json',
                url:'/cart/change.js',
                async: false,
                data:body,
                success: function(data) {
                  const parsedState = data;
        _this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        _this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            _this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

       // _this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
                },
             error:function(response){
               console.log(response);
               return false;
             }
           });
    
    }
          if($(this).attr('data-meta-bundle')=='false' && !$(this).attr('data-item-random') && $(this).attr('data_type') != 'Mobile Case'){
               flag =1 
            }
           
            if(flag == 0 ){
            
                $('.main-product-type-bundle').addClass('hide_bndl');
            }else if (flag =1 ){
             
             $('.main-product-type-bundle').removeClass('hide_bndl');
                
            }

      });
        }
        if(monogram_cart == 1){
    var mongram_QTY = 0;
      $('cart-items .cart-item').each(function(index){
       if ($(this).find("quantity-input .quantity__input").hasClass('monogram_line_property') == true){
           mongram_QTY = mongram_QTY + parseInt($(this).find("quantity-input .quantity__input.monogram_line_property").attr('value'));
       }

      });
         var body = { quantity:mongram_QTY, id:30672622157893, sections:_this.getSectionsToRender().map((section) => section.section),sections_url: window.location.pathname};
             $.ajax({
                method: "POST",
                dataType: 'json',
                url:'/cart/change.js',
                async: false,
                data:body,
                success: function(data) {
                   const parsedState = data;
        _this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        _this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            _this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        _this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
                },
             error:function(response){
               console.log(response);
               return false;
             }
           });
     
        }

        this.disableLoading();
      }).catch(() => {
           $('.cart-item[data_type="Mobile Case"]').each(function(){
     var data_variant = $(this).attr('data-variant');
        $('.main-bundle-product-container.mobile-cart-drawer[data-variant="'+data_variant+'"]').addClass('active_bundel');
        
    });
        
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    var bogo_less_pd = $('.cart-item[data-bogo="false"]').length;
  var hide_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list.cart-hidden').length
            var hide_bundle_pd =$('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list.cart-hidden').length
            var total_hide_bundle_pd = hide_mobile_bundle_pd+hide_bundle_pd;
            console.log(total_hide_bundle_pd);
            var total_mobile_bundle_pd = $('cart-drawer .grid__item.bundle-product-list').length;
            var total_bundle_pd = $('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list').length;
            var total_bundle_pd_main = total_mobile_bundle_pd+total_bundle_pd;
            console.log(total_bundle_pd_main);
            
            var total_show_pd = total_bundle_pd_main-total_hide_bundle_pd;
            console.log(total_show_pd);
            if(total_show_pd < 1){
                $('cart-drawer .drawer_upsells').addClass('hide_active');
            }else{
               if(bogo_less_pd >= 1){
                 $('cart-drawer .drawer_upsells').removeClass('hide_active');
               }
            }
//     setTimeout(function(){
//  var hide_bndle_notebook_meta = $('.main-bundle-metaobjects .grid__item.bundle-product-list.cart-hidden').length;
// var show_bndle_notebook = $('.main-bundle-metaobjects .grid__item.bundle-product-list').length;
// var hdie_mobile = $('.main-mobile-bndle .main-bundle-product-container.active_bundel .grid__item.bundle-product-list').length;
// var show_mobile = $('.main-mobile-bndle .grid__item.bundle-product-list.cart-hidden').length;
// var main_bundle_pd_note_book = $('.main-product-type-bundle').hasClass('hide_bndl');
// console.log(main_bundle_pd_note_book);
// if(hide_bndle_notebook_meta == show_bndle_notebook && hdie_mobile == show_mobile && main_bundle_pd_note_book == true){

//    $('.drawer_upsells').addClass('hide_active');
// } 
//       },300)
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};